var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',_vm._b({attrs:{"type":"datetime-local","dense":"","value":_vm.raw,"rules":_vm.rules},on:{"input":_vm.updateValue}},'v-text-field',_vm.attrsModified,false))}
var staticRenderFns = []

export { render, staticRenderFns }